export default __webpack_public_path__ + "i18n/de.d39564f25cba5e212de4b0fa7a6efe51.json";